import { render, staticRenderFns } from "./yzgrade.vue?vue&type=template&id=6fecff66&scoped=true&"
import script from "./yzgrade.vue?vue&type=script&lang=js&"
export * from "./yzgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecff66",
  null
  
)

export default component.exports